import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import PostHeader from '../services/PostHeader';

import { nexcareVersion } from '../config/serviceConfig';

const getVersionRelease = () => Get(`/${nexcareVersion}/nexcare/version-release`);

const postDataAuthorize = () => Post(`/${nexcareVersion}/nexcare/session/authorize`);
const postDataVerify = (data, token) => Post(`/${nexcareVersion}/nexcare/session/verify`, data, token);
const postDataLogin = (data) => Post(`/${nexcareVersion}/nexcare/session/token`, data);
const postDataLogout = (token) => Post(`/${nexcareVersion}/nexcare/session/logout`, null, token);

const postRoleUser = (data, token) => Post(`/${nexcareVersion}/nexcare/role/front-end`, data, token);
const postDetailUser = (data, token) => Post(`/${nexcareVersion}/nexcare/internal/users/detail`, data, token);

const postRefreshToken = (data, token) => Post(`/${nexcareVersion}/nexcare/session/token`, data, token);

const postResetPassword = (data) => Post(`/${nexcareVersion}/nexcare/users/email/forget`, data);
const postNewPassword = (data) => PostHeader(`/${nexcareVersion}/nexcare/users/email/password`, data);

const postChangePassword = (data, token) => Post(`/${nexcareVersion}/nexcare/users/change-password`, data, token);

const postVerifyUser = (data, token) => Post(`/${nexcareVersion}/nexcare/internal/users/code`, data, token);

const putChangeName = (data, id, token) => Put(`/${nexcareVersion}/nexcare/users/${id}`, data, token);

const getParameterForceLogout = (token) => Get(`/${nexcareVersion}/nexcare/parameter/force-log-out-desktop`, token);

const getGrochatInternalToken = () => Get(`/${nexcareVersion}/nexcare/session/grochat/internal-token`);
const postGrochatLogin = (data) => Post(`/${nexcareVersion}/nexcare/session/grochat/login`, data);
const getAssetLinks = () => Get(`/${nexcareVersion}/nexcare/.well-known/assetlinks.json`);

const postGrochatAccountMigrate = (token) => Post(`/${nexcareVersion}/nexcare/session/grochat/migrate`, null, token);

const API_AUTHENTICATION = {
    getVersionRelease,
    postDataAuthorize,
    postDataVerify,
    postDataLogin,
    postDataLogout,
    postRoleUser,
    postDetailUser,
    postRefreshToken,
    postResetPassword,
    postNewPassword,
    postChangePassword,
    postVerifyUser,
    putChangeName,
    getParameterForceLogout,
    getGrochatInternalToken,
    postGrochatLogin,
    getAssetLinks,
    postGrochatAccountMigrate
}

export default API_AUTHENTICATION;